export default "__VITE_ASSET__b6a3109e__"